import React, { useState, useEffect } from 'react';

const OneTrust = () => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        {
            !isLoaded &&
                loadScript();
        }
    }, []);

    const loadScript = () => {
        var s = document.createElement('script');
        s.setAttribute("src", "//cdn.cookielaw.org/scripttemplates/otSDKStub.js");
        s.setAttribute("type", "text/javascript");
        s.setAttribute("charset", "UTF-8");
        s.setAttribute("data-document-language", "true");
        s.setAttribute("data-domain-script", 'adbbd329-6cbb-4f68-9d50-e2ba7a82ce14');
        s.onreadystatechange = function () {
            if (this.readyState === 'complete' || this.readyState === 'loaded') {
                setIsLoaded(true);
            }
        };
        s.onload = () => setIsLoaded(true);
        document.getElementsByTagName('head')[0].appendChild(s);

        // Setting up UET for Consent Mode
        // window.uetq = window.uetq || [];
        // window.uetq.push('consent', 'default', {
        //     'ad_storage': 'denied'
        // });
        // window.uetq.push('consent', 'update', {
        //     'ad_storage': 'granted'
        // });

        // window.uetq.push('consent', 'default', {
        //     'ad_user_data': 'denied'
        // });
        // window.uetq.push('consent', 'update', {
        //     'ad_user_data': 'granted'
        // });

        // window.uetq.push('consent', 'default', {
        //     'analytics_storage': 'denied'
        // });
        // window.uetq.push('consent', 'update', {
        //     'analytics_storage': 'granted'
        // });
        // window.uetq.push('consent', 'default', {
        //     'ad_personalization': 'denied'
        // });
        // window.uetq.push('consent', 'update', {
        //     'ad_personalization': 'granted'
        // });
        
    };

    return (
        <></>
    );
}

export default OneTrust;